























































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateMiniAppConfig from "./createminappconfig.vue";
import EditMiniAppConfig from "./editminappconfig.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";
import SearchTree from "@/lib/Common/searchtree";


class PageUserRequest extends PageRequest {
  organizationId: number;
  keyword: string;
  isEnable: number;
}

@Component({
  components: { CreateMiniAppConfig, EditMiniAppConfig },
})
export default class MiniAppConfig extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }

  pagerequest: PageUserRequest = new PageUserRequest();
  creationTime: Date[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  treedata: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  splitnum: number = 0.15;

  get list() {
    return this.$store.state.miniappconfig.list;
  }
  get loading() {
    return this.$store.state.miniappconfig.loading;
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.treedata = this.areaTreeList;
      return;
    }
    //this.treedata = [];
    this.treedata = SearchTree.searnchTree(value, treeList);
  }
  async itemtree() {
    await this.$store
      .dispatch("organization/getCommanyItemTree")
      .then((val) => {
        this.treedata = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  create() {
    this.createModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("miniappconfig/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("miniappconfig/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.organizationId = item[0].id;
    }
    this.$store.commit("miniappconfig/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("miniappconfig/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "miniappconfig/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.miniappconfig.pageSize;
  }
  get totalCount() {
    return this.$store.state.miniappconfig.totalCount;
  }
  get currentPage() {
    return this.$store.state.miniappconfig.currentPage;
  }
  columns = [
    {
      title: this.L("IndexNo"),
      type: "index",
      width: 70,
      align: "left",
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 150,
      fixed: "left",
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].displayName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Name"),
      key: "miniAppName",
      width: 160,
      fixed: "left",
      sortable: true,
    },
    {
      title: this.L("AppId"),
      width: 160,
      key: "appId",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.appId,
            },
          },
          params.row.appId
        );
      },
    },
    {
      title: this.L("AppSecret"),
      width: 160,
      key: "appSecret",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.appSecret,
            },
          },
          params.row.appSecret
        );
      },
    },
    {
      title: this.L("IsEnable"),
      sortable: true,
      width: 160,
      key: "isEnable",
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('miniappconfigDel');
        let edit = this.checkButtonAuth('miniappconfigEdit');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("miniappconfig/edit", params.row);
                  //console.log(params.row)
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "miniappconfig/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.itemtree();
    this.pagerequest.isEnable = 9;
    this.getpage();
  }
  data() {
    return {
      paytype: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
